/* eslint-disable class-methods-use-this */
import { DateTime } from 'luxon';

const MEXICO_HOLIDAYS_2025 = [
  '2025-01-01',
  '2025-02-03',
  '2025-03-17',
  '2025-05-01',
  '2025-09-16',
  '2025-11-02',
  '2025-11-17',
  '2025-12-12',
  '2025-12-25',
];

const MEXICO_HOLIDAYS_2026 = [
  '2026-01-01',
  '2026-02-02',
  '2026-03-16',
  '2026-05-01',
  '2026-09-16',
  '2026-11-02',
  '2026-11-16',
  '2026-12-12',
  '2026-12-25',
];

const USA_HOLIDAYS_2025 = [
  '2025-01-01',
  '2025-01-20',
  '2025-02-17',
  '2025-05-26',
  '2025-06-19',
  '2025-07-04',
  '2025-09-01',
  '2025-10-13',
  '2025-11-11',
  '2025-11-17',
  '2025-11-27',
  '2025-12-12',
  '2025-12-25',
];

const USA_HOLIDAYS_2026 = [
  '2026-01-01',
  '2026-01-19',
  '2026-02-02',
  '2026-02-16',
  '2026-03-16',
  '2026-04-02',
  '2026-04-03',
  '2026-05-01',
  '2026-05-25',
  '2026-06-19',
  '2026-07-04',
  '2026-09-07',
  '2026-10-12',
  '2026-11-11',
  '2026-11-16',
  '2026-11-26',
  '2026-12-12',
  '2026-12-25',
];

const MEXICO_HOLIDAYS_2027 = ['2027-01-01'];

const USA_HOLIDAYS_2027 = ['2027-01-01'];

const convertDate = (date: string) => {
  const [year, month, day] = date.split('-');
  return DateTime.local(Number(year), Number(month), Number(day));
};

const DISABLED_DATES = [
  ...MEXICO_HOLIDAYS_2025.map(convertDate),
  ...MEXICO_HOLIDAYS_2026.map(convertDate),
  ...MEXICO_HOLIDAYS_2027.map(convertDate),
  ...USA_HOLIDAYS_2025.map(convertDate),
  ...USA_HOLIDAYS_2026.map(convertDate),
  ...USA_HOLIDAYS_2027.map(convertDate),
];

export default class DateService {
  isDateToday = (date: DateTime) => {
    const today = DateTime.local().startOf('day');
    return date.startOf('day').equals(today);
  };

  isDateWeekEnd = (date: DateTime) => {
    const dayOfWeek = date.weekday - 1;
    return dayOfWeek === 5 || dayOfWeek === 6;
  };

  isDateHoliday = (date: DateTime) =>
    DISABLED_DATES.some(
      (holiday) =>
        holiday.year === date.year &&
        holiday.month === date.month &&
        holiday.day === date.day
    );

  isDateDisabled = (date: DateTime) =>
    this.isDateWeekEnd(date) ||
    this.isDateHoliday(date) ||
    this.isDateToday(date);

  addDaysToDate = (date: string, days: number) => {
    const dateObj = DateTime.fromISO(date.split(' ')[0]);
    return dateObj.plus({ days });
  };

  /**
   * Format a date to the format “dd/mm/yyyy”.
   * @param date - The date to format.
   * @returns A string in the format “dd/mm/yyyy”.
   */
  static formatDate(date: Date): string {
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
}
